'use strict';
///*------------------------------------------------
///* изменение положения забора в секции about
///* при ресайзе окна, чтобы скрыть прозрачный низ png
///* картинки и сохранить пропорции забора 
///*------------------------------------------------
const resizeZabor = (() => {
  const body = document.body,
    zaborDiv = body.querySelector('.zabor-bg');
  const moveZabor = () => {
    //*** size footer_zabor.png: 1280px*114px
    //*** высота прозрачной области, которую нужно сдвинуть: 21px
    const wrapper = body.querySelector('.wrapper'),
      sizeOfWrapper = wrapper.getBoundingClientRect(),
      widthWrapper = sizeOfWrapper.width,
      zaborStyle = zaborDiv.style,
      zaborWidthInitial = 1280,
      moveY = widthWrapper * 21 / zaborWidthInitial;
    zaborStyle.transform = `translateY(${moveY}px)`;
    zaborStyle.WebkitTransform = `translateY(${moveY}px)`;
  };
  const handler = () => {
    moveZabor();   
    window.addEventListener('resize', moveZabor);
  };
  return {handler};
})();

export default resizeZabor;


// WEBPACK FOOTER //
// ./app/components/resize_zabor.js